import OneIdWeb from '@datafe/oneid-web-sdk'
import { getInWindowsApp } from '@RootCommon/utils'

export const initOneIdWeb = async () => {
  let webId = ''
  // 在OM中使用Electron壳子的oneid
  if (getInWindowsApp()) {
    webId = await window.electronAPI.oneIdAPI.getAsyncWebID()
  }

  // 兜底使用浏览器sdk获取oneId
  if (!webId) {
    webId = await OneIdWeb.getAsyncWebID()
  }

  window.getWebId = () => webId

  return webId
}